{
  "farsi": false,
  "focus": true,
  "timer": false
}
